import { useApolloClient } from '@apollo/client/react';
import { Formik } from 'formik';
import NewEmailInvitesForm, { newEmailInvitesSchema } from '../new-email-invites-form';
import { createEventEmailInvitesMutation, eventInvitesQuery } from '../../apollo/events';
import { splitEmailInvitesBody } from '../../utils/invites';
import type { Event } from '../../types/Event';

type Props = {
  event?: Event;
  disabled?: boolean;
};

const NewEventEmailInvites = ({ event, disabled }: Props) => {
  const client = useApolloClient();
  return (
    <Formik
      initialValues={{
        body: ''
      }}
      validationSchema={newEmailInvitesSchema}
      onSubmit={(values, actions) => {
        client.mutate({
          mutation: createEventEmailInvitesMutation,
          variables: {
            eventId: event.id,
            emails: splitEmailInvitesBody(values.body)
          },
          update: (proxy, { data: { createEventEmailInvites: newInvites } }) => {
            const listVariables = { id: event.id };
            const data = proxy.readQuery({
              query: eventInvitesQuery,
              variables: listVariables
            })
            proxy.writeQuery({
              query: eventInvitesQuery,
              data: {
                ...data,
                event: {
                  ...data.event,
                  emailInvites: [...newInvites, ...data.event.emailInvites]
                }
              },
              variables: listVariables
            })
          }
        }).then(() => {
          actions.setSubmitting(false);
          actions.resetForm();
        }).catch((error) => {
          actions.setSubmitting(false);
          console.log(error);
          // actions.setErrors();
          // actions.setStatus();
        });
      }}
    >
      <NewEmailInvitesForm disabled={disabled} />
    </Formik>
  );
}

export default NewEventEmailInvites;
